import { Model } from '@nozbe/watermelondb'
import { field } from '@nozbe/watermelondb/decorators'

export class PricesDataModel extends Model {

  static table = 'pricesData'

  @field('pricesDataId')
  pricesDataId: string

  @field('dairyFarmId')
  dairyFarmId: string

  @field('price')
  price: string

  @field('companyName')
  companyName: string

  @field('organizationId')
  organizationId: string

  @field('manual')
  manual: boolean

  @field('priceDate')
  priceDate: string

  @field('userId')
  userId: string

  @field('monthlyIncome')
  monthlyIncome: string

  @field('costBulkId')
  costBulkId: string

  @field('deletedAt')
  deletedAt: string

  @field('userStateRegistrationId')
  userStateRegistrationId: string

  @field('createdAt')
  createdAt: string

  @field('updatedAt')
  updatedAt: string

}
